import { Link } from 'react-router-dom';
import { categories, dramas } from '@/mocks/dramas';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function CategoryShowcase() {
  const selectedCategories = categories.slice(0, 4);

  return (
    <ScrollReveal>
    <section className="bg-background-100/50 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
            <i className="ri-grid-line text-secondary-500 mr-2"></i>
            分类精选
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型发现你喜欢的剧集</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {selectedCategories.map((cat) => {
            const catDramas = dramas.filter((d) => d.categorySlug === cat.slug).slice(0, 4);
            return (
              <div key={cat.slug} className="bg-background-50 rounded-xl p-5 border border-background-300/60 hover:border-primary-500/20 transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-base font-heading font-bold text-foreground-200">
                    {cat.name}
                  </h3>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-xs text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    全部 <i className="ri-arrow-right-s-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-4 gap-3">
                  {catDramas.map((drama) => (
                    <Link
                      key={drama.id}
                      to={`/article/${drama.id}`}
                      className="group cursor-pointer"
                    >
                      <div className="relative rounded-lg overflow-hidden mb-2" style={{ aspectRatio: '2/3' }}>
                        <img
                          src={drama.cover}
                          alt={drama.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          loading="lazy"
                        />
                        <div className="absolute top-1 left-1">
                          <span className="text-[10px] bg-primary-500/90 text-background-950 font-bold px-1.5 py-0.5 rounded">
                            {drama.rating}
                          </span>
                        </div>
                      </div>
                      <p className="text-xs text-foreground-300 group-hover:text-primary-500 transition-colors duration-200 truncate text-center">
                        {drama.title}
                      </p>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
    </ScrollReveal>
  );
}